/** Host suffix for tenant subdomains. Display only. */
export const PLATFORM_DOMAIN: string = import.meta.env.VITE_PLATFORM_DOMAIN || 'scorelm.com'
import type { TenantDetail, TenantSummary } from '@/api/types'
import { hostUrl } from './format'

export interface TenantLinks {
  /** Where fans actually land: the custom domain once it's verified, else the subdomain. */
  publicUrl: string | null
  publicHost: string | null
  subdomainUrl: string | null
  customUrl: string | null
  /** The tenant's own admin (league admins sign in here). */
  adminUrl: string | null
}

/**
 * Public links for a tenant that respect the custom domain: a verified
 * custom domain is the canonical address (the subdomain may even redirect
 * to it); an unverified one isn't linked as primary because it may not
 * resolve yet.
 */
export function tenantLinks(t: Pick<TenantSummary, 'subdomain' | 'custom_domain' | 'custom_domain_verified_at'> & Partial<Pick<TenantDetail, 'domains'>>): TenantLinks {
  const subHost = t.domains?.subdomain_host || (t.subdomain ? `${t.subdomain}.${PLATFORM_DOMAIN}` : null)
  const customActive = !!t.custom_domain && (t.domains ? t.domains.custom_domain_state === 'active' : !!t.custom_domain_verified_at)
  const publicHost = customActive ? t.custom_domain : subHost
  // The server says where the subdomain is served here (a local stack is http://<sub>.localhost:<port>), #623.
  const subdomainUrl = t.domains?.subdomain_url || (subHost ? hostUrl(subHost) : null)
  const publicUrl = customActive && t.custom_domain ? hostUrl(t.custom_domain) : subdomainUrl
  return {
    publicUrl,
    publicHost,
    subdomainUrl,
    customUrl: t.custom_domain ? hostUrl(t.custom_domain) : null,
    adminUrl: publicUrl ? `${publicUrl}/admin` : null,
  }
}
